import { useTranslate } from 'core/hooks/useTranslate';
import { Dialog, TextHtml } from 'ui';
import * as coreEntities from 'core/store/index';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const DialogInfo = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const infoDialog = useSelector((state) => coreEntities.ui.selectors.getInfoDialog(state));

  useEffect(() => {
    if (infoDialog && infoDialog.text) {
      setText(infoDialog.text);
      setIsOpen(true);
    }
  }, [infoDialog.text]);

  const [isOpen, setIsOpen] = useState(false);
  const [text, setText] = useState('');

  function closeDialog() {
    dispatch(coreEntities.ui.actions.setShowInfoDialog({ text: null }));
    setIsOpen(false);
  }

  return (
    <Dialog ariaLabel={t('common:Information')} size="l" isOpen={isOpen} className={'dialog-info'} onClose={closeDialog}>
      <div className="dialog-info__container">
        <TextHtml text={text} className="dialog-info__text" />
      </div>
    </Dialog>
  );
};

export default DialogInfo;
